<script setup lang="ts">
// The bar along the bottom of every page: the connection on the left, the
// last thing said (a save, a copy, a failure) beside it with its time. It
// is always there and holds its message until the next one, instead of a
// toast that covered the page and went away by itself. A message settles
// to the secondary colour after a few seconds; a failure stays red.
import { useNode } from '../store'
import { dot } from '../util'
import { newVersion } from '../update'

const node = useNode()
const reload = () => location.reload()
const time = (ms: number) => new Date(ms).toLocaleTimeString([], { hour12: false })
</script>

<template>
    <footer
        class="flex h-7 flex-none items-center gap-3 border-t border-line bg-bg-1 px-3 text-xs text-fg-2"
        data-test="status-bar"
    >
        <span v-if="!node.fleet" class="inline-flex flex-none items-center gap-1.5" data-test="connection">
            <span :class="[dot(node.connected ? 'ok' : 'bad'), { 'animate-pulse-dot': !node.connected }]" />
            <span :class="{ 'text-bad': !node.connected }">{{ node.connected ? 'connected' : 'disconnected' }}</span>
        </span>
        <span v-if="!node.fleet" class="h-3.5 w-px flex-none bg-line" />
        <span
            :key="node.toastAt"
            class="min-w-0 flex-1 truncate"
            :class="node.toastBad ? 'text-bad' : 'animate-settle text-fg'"
            :role="node.toastBad ? 'alert' : 'status'"
            :title="node.toast"
        >
            <template v-if="node.toast"
                ><span class="mr-2 font-mono text-fg-3 tabular-nums">{{ time(node.toastAt) }}</span
                >{{ node.toast }}</template
            >
        </span>
        <!-- a deploy since this page loaded: its drawers' code is gone until a reload (update.ts) -->
        <button
            v-if="newVersion"
            type="button"
            class="flex-none btn-primary px-2 py-0 text-xs"
            data-test="new-version"
            @click="reload"
        >
            New version · reload
        </button>
        <span class="flex-none text-fg-3" title="BLAST Streaming & Encoding Platform">BSEP</span>
    </footer>
</template>
